import { jsx as _jsx } from "react/jsx-runtime";
import { FlameS } from '@lichtblick/photon/icons/energy/flame-s';
import { FlashS } from '@lichtblick/photon/icons/energy/flash-s';
const electricityFields = {
    consumption: 'energyAnualConsumptionPlan',
    meters: 'energyMeterCount'
};
const gasFields = {
    consumption: 'gasAnualConsumptionPlan',
    meters: 'gasMeterCount'
};
export const COMMODITIES = {
    ELECTRICITY: {
        fields: electricityFields,
        formName: 'B2BElectricity',
        headline: 'Jetzt GewerbeStrom anfragen',
        id: 'gewerbestrom-formular',
        option: {
            fields: gasFields,
            headline: 'Sind Sie auch an einem ÖkoGas Tarif interessiert?',
            icon: /*#__PURE__*/ _jsx(FlameS, {}),
            label: 'GewerbeGas'
        }
    },
    GAS: {
        fields: gasFields,
        formName: 'B2BGas',
        headline: 'Jetzt GewerbeGas anfragen',
        id: 'gewerbegas-formular',
        option: {
            fields: electricityFields,
            headline: 'Sind Sie auch an einem ÖkoStrom Tarif interessiert?',
            icon: /*#__PURE__*/ _jsx(FlashS, {}),
            label: 'GewerbeStrom'
        }
    }
};

//# sourceMappingURL=Form.content.js.map